export default __webpack_public_path__ + "static/media/fav-gray.cf583428.svg";